'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/hasown/~/function-bind/index.js
// module id = 918
// module chunks = 1